// @flow

import PropTypes from 'prop-types';
import * as React from 'react';

export type IceCount = { price: number, ts: number, count: number };

export class IceCountIndicator extends React.Component<{
  scale: number,
  iceCounts: IceCount[],
  onAnimationEnd: IceCount => void,
}> {
  static propTypes = {
    iceCounts: PropTypes.array.isRequired,
    onAnimationEnd: PropTypes.func.isRequired,
  };

  render(): React.Node {
    return this.props.iceCounts.map(iceCount => {
      let totalPrice = iceCount.price * iceCount.count;
      let size = (totalPrice / 270.0 + 1.0) / 2.5 + 0.5; // size adjust. Ike's algorithm
      const style = {
        top: this.props.scale * 307 - this.props.scale * 71 * size,
        left: this.props.scale * 235,
        width: this.props.scale * 59 * size,
        height: this.props.scale * 71 * size,
        padding: `${this.props.scale * 13 * size}px ${this.props.scale * 10 * size}px 0`,
      };

      const priceFontStyle = {
        textAlign: 'center',
        fontSize: this.props.scale * size * 1.4 + 'em',
        lineHeight: 1,
      };

      const countFontStyle = {
        textAlign: 'center',
        fontSize: this.props.scale * size * 1.0 + 'em',
        lineHeight: 1,
      };
      return (
        <div
          style={style}
          key={iceCount.ts}
          className="ice-count"
          onAnimationEnd={() => {
            this.props.onAnimationEnd(iceCount);
          }}
        >
          <div style={priceFontStyle}>{iceCount.price}</div>
          <div style={countFontStyle}>{`x ${iceCount.count}`}</div>
        </div>
      );
    });
  }
}
